<script>
import {mapGetters, mapActions} from "vuex";
import appStatuses from "../../service/contract-statuses";

import AppConfirm from "../../components/modals/app-confirm.vue";
import AdminContractPage from "../../components/AdminContractLotinPage.vue";
import AdminContractSchetSummPage from "~/src/components/AdminContractSchetSummLotinPage.vue";
import AdminContractSchetSummPagePechat from "~/src/components/AdminContractSchetSummLotinPagePechat.vue";
import AdminContractPaidShow2025 from "~/src/components/AdminContractPaidShow2025.vue";
import AdminContractPaidEdit2025 from "~/src/components/AdminContractPaidEdit2025.vue";
import AddGroupNumber2025 from "~/src/components/AddGroupNumber2025.vue";
import AdminContractPaidPayment2025 from "~/src/components/AdminContractPaidPayment2025.vue";
import EditContractNumber2025 from "~/src/components/EditContractNumber2025.vue";
import AdminAddPromotion2025 from "~/src/components/AdminAddPromotion2025.vue";
import axios from 'axios'
import CreditHistory from "~/src/components/CreditHistory.vue";
import ContractComments from "~/src/components/ContractComments.vue";
import { loadDraft, saveTab, loadTab } from "~/src/utils/contract-edit-draft";
import { readableTextOn } from "~/src/utils/readable-text";

export default {
  components: {
    AdminContractSchetSummPage,
    AdminContractPaidShow2025,
    AppConfirm,
    AdminContractPage,
    AdminContractPaidEdit2025,
    AddGroupNumber2025,
    AdminContractPaidPayment2025,
    AdminContractSchetSummPagePechat,
    EditContractNumber2025,
    AdminAddPromotion2025,
    CreditHistory,
    ContractComments,
  },

  data: () => ({
    tabs: {
      personal: "Personal info",
      edit: "Edit",
      payment: "Payment",
      groupAdd: "Add Group Number",
      editContractNumber: "Contract Number",
      promotion: "VAUCHER",
      credit: "Kredit tarixi",
    },

    tab: "Personal info",
    loading: false,
    deleteDialog: false,
    isContract: false,
    isInvoice: false,
    isInvoicePechat: false,
    pdfData: null,

    // Comment section state
    comments: [],
    newComment: "",
    postingComment: false,
    loadingComments: false,
    // A MASTER student renders master_template_id(_ru). The documents from Scho't faktura down carry no
    // bachelor/master wording, so masters get the same file as everyone else. "2 tomonlama shartnoma
    // imzosiz" (6000/60001) is written for Bakalavriat and has no master version, so it has no master id.
    buttons: [
      {label: "2 tomonlama shartnoma imzosiz", abit_template_id: 6000, abit_template_ru: 60001},
      {label: "2 tomonlama shartnoma", abit_template_id: 1000, abit_template_ru: 10001, master_template_id: 3000, master_template_id_ru: 3000},
      {label: "3 tomonlama shartnoma imzosiz", abit_template_id: 2000, abit_template_ru: 20001, master_template_id: 2100, master_template_id_ru: 21001},

      // { label: "Atsverka uchun shartnoma", abit_template_id: 4000, abit_template_ru: 40001 },
      {label: "Scho't faktura", abit_template_id: 4000, abit_template_ru: 40001, master_template_id: 4000, master_template_id_ru: 40001},
      {label: "Mahalla uchun shartnoma", abit_template_id: 7000, abit_template_ru: 70001, master_template_id: 7000, master_template_id_ru: 70001},
      {label: "Korzinka uchun shartnoma", abit_template_id: 8000, abit_template_ru: 80001, master_template_id: 8000, master_template_id_ru: 80001},
      {label: "Kredit modul uchun shartnoma", abit_template_id: 5000, abit_template_ru: 50001, master_template_id: 5000, master_template_id_ru: 50001},
      {label: "Bitiruvchi amalyoti", abit_template_id: 11000, abit_template_ru: 11000, master_template_id: 11000, master_template_id_ru: 11000},
      // Malakaviy amaliyot shartnomasi: one Uzbek document, so both languages render the same code.
      {label: "Tashkilot shartnomasi", abit_template_id: 9000, abit_template_ru: 9000, master_template_id: 9000, master_template_id_ru: 9000},
    ],
    credit: "Kredit tarixi",
    canExport: false,
    canDelete: false,
    canUpdate: false,
    canCreate: false
  }),

  async mounted() {
    this.canExport = await this.hasRole("KONTRAKT_25_26", "EXCEL");
    this.canDelete = await this.hasRole("KONTRAKT_25_26", "DELETE");
    this.canUpdate = await this.hasRole("KONTRAKT_25_26", "UPDATE");
    this.canCreate = await this.hasRole("KONTRAKT_25_26", "CREATE");
  },

  computed: {
    ...mapGetters("admin-contracts2025", ["GET_APPLICATION"]),
    application: (vm) => vm.GET_APPLICATION,

    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,

    isSupperAdmin: (vm) => vm.user.role == "ADMIN_SUPER",
    isAccounter: (vm) => vm.user.role == "ACCOUNTER",
    isAccounterHelper: (vm) => vm.user.role == "ACCOUNTER_HELPER",
    isQabulQiluvchi: (vm) => vm.user.role == "QABUL_QILUVCHI",
    // Bitrix menejeri is strictly read-only: the record opens, but no button on it acts.
    // Document generation and the comment box are not covered by a CRUD op, so they are gated here.
    isBitrixManager: (vm) => vm.user.role == "BITRIX_MANAGER",

    applicationStatus() {
      const status = appStatuses.find((x) => x.id == this.application.paidStatus) || {};
      return {
        name: status[`name-${this.$i18n.locale}`],
        color: color(status.id),
      };

      function color(statusName) {
        switch (statusName) {
          case "PAID":
            return "#26d317";
          case "HALF_PAID":
            return "#d8d813";
          case "NOT_PAID":
            return "#Fb0607";
          default:
            return null;
        }
      }
    },
  },


  created() {

    const id = this.$route.params.id;
    if (id != this.application.id) {
      this.INIT_BY_ID({id}).then((status) => {
        if (!status) {
          this.$router.replace("/dashboard");
          return;
        }
      });
    }
    this.loadComments();
  },

  watch: {
    'this.$route.params.id': {
      handler(newId) {
        this.initialize(newId);
      },
      immediate: true,
    },
    tab(v) {
      const id = this.application?.id;
      if (id) saveTab(2025, id, v);
    },
  },

  activated() {
    this.initialize();
  },

  methods: {
    // Dark text on the light status fills (the "Qisman" yellow, the "To'liq" green), white on the rest.
    textOn: readableTextOn,

    ...mapActions("admin-contracts2025", ["INIT_BY_ID", "DELETE_APPLICATION"]),
    ...mapActions("admin-contract2025", ["INIT_APPLICATION", "INIT_HISTORY", "INIT_ADD_GROUP"]),

    async initialize(newId) {
      await this.INIT_BY_ID({ newId });
      await this.restoreDraft();
    },

    async restoreDraft() {
      const id = this.application?.id;
      if (!id) return;
      const draft = loadDraft(2025, id);
      const savedTab = loadTab(2025, id);
      if (draft) {
        // Seed the singular store the edit subcomponent reads from with
        // the in-progress draft, so the user lands back on their edits.
        await this.INIT_APPLICATION(draft);
        this.tab = this.tabs.edit;
      } else if (savedTab && Object.values(this.tabs).includes(savedTab)) {
        this.tab = savedTab;
        if (savedTab !== this.tabs.personal) {
          await this.INIT_APPLICATION(this.application);
        }
      }
    },

    navigateToAdmin() {
      this.$router.go(-1);
    },

    async hasRole(panel, op) {
      try {
        const res = await axios.get(`/admin/panel-permissions/check`, {
          params: {appPanel: panel, op}
        });
        return res.data === true;
      } catch {
        return false;
      }
    },

    onCredit() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.credit;
      });
    },

    async generateContract(template_id) {
      const contractId = this.application?.id;
      if (!contractId) {
        this.$emit("error", "Contract ID not found.");
        return;
      }

      // A MASTER applicant clicking a button that has no master_template_id configured used to
      // send template_id=undefined and get a 400 back — the "PDF button ids not configured"
      // symptom. Stop before the request and say so, rather than firing a broken URL at the API.
      if (template_id === undefined || template_id === null) {
        this.$store.dispatch("SET_SNACKBAR", {
          text: this.$t("Bu talaba turi uchun ushbu shartnoma sozlanmagan"),
          color: "error",
        });
        return;
      }

      this.loadingId = template_id;

      try {
        const locale = this.$i18n.locale;
        const res = await axios.get(
            `/admin/contract2025/contract?contract_id=${contractId}&template_id=${template_id}&locale=${locale}`,
            {responseType: "blob"}
        );

        const blob = new Blob([res.data], {type: "application/pdf"});
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${this.application.firstName + " " + this.application.lastName + " " + this.application.middleName}.pdf`;
        link.click();
      } catch (e) {
        console.error(e);
        this.$emit("error", "Xatolik yuz berdi");
      } finally {
        this.loadingId = null;
      }
    },


    getVaucherText(promValue) {
      return promValue <= 100
          ? `Vaucher berilgan, miqdori: ${promValue} %`
          : `Vaucher berilgan, miqdori: ${promValue} so'm`;
    },

    onEdit() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.edit;
      });
    },

    onPayment() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.payment;
      });
    },

    onPromotion() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.promotion;
      });
    },

    onDelete() {
      this.loading = true;
      this.DELETE_APPLICATION(this.application).then((status) => {
        this.loading = false;
        if (status) {
          this.$router.replace("/contract_2025_2026");
        }
      });
    },

    onAddModel() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.groupAdd;
      });
    },

    onEditContractNumber() {
      this.loading = true;
      this.INIT_APPLICATION(this.application).then(() => {
        this.loading = false;
        this.tab = this.tabs.editContractNumber;
      });
    },

    async onDownloadContract() {
      this.loading = true;
      const id = this.application.id;
      const data = await this.$axios.$get(`admin/contract2025/invoice/${id}`);
      if (data) {
        this.pdfData = {...data, contractId: id};
        this.$nextTick(() => (this.isContract = true));
      } else {
        this.loading = false;
      }
    },

    async onDownloadContractInvoice() {
      this.loading = true;
      const id = this.application.id;
      const data = await this.$axios.$get(`admin/contract2025/invoice/${id}`);
      if (data) {
        this.pdfData = {...data, contractId: id};
        this.$nextTick(() => (this.isInvoice = true));
      } else {
        this.loading = false;
      }
    },

    async onDownloadContractInvoicePechat() {
      this.loading = true;
      const id = this.application.id;
      const data = await this.$axios.$get(`admin/contract2025/invoice/${id}`);
      if (data) {
        this.pdfData = {...data, contractId: id};
        this.$nextTick(() => (this.isInvoicePechat = true));
      } else {
        this.loading = false;
      }
    },

    // Comment system methods
    async loadComments() {
      this.loadingComments = true;
      try {
        const id = this.$route.params.id;
        this.comments = await this.$axios.$get(`/admin/contract2025/comment?contractId=${id}`);
      } catch (e) {
        console.error("Failed to load comments", e);
      } finally {
        this.loadingComments = false;
      }
    },

    async postComment() {
      if (!this.newComment.trim()) return;
      this.postingComment = true;
      try {
        const dto = {
          contract2025_id: this.$route.params.id,
          comment: this.newComment.trim(),
          firstName: this.user.firstName,
          lastName: this.user.lastName,
        };
        const saved = await this.$axios.$post(`/admin/contract2025/comment`, dto);
        this.comments.unshift(saved);
        this.newComment = "";
      } catch (e) {
        console.error("Comment submission failed", e);
      } finally {
        this.postingComment = false;
      }
    },

    handleContractClick(button) {
      console.log(
          this.application.typeAbiturient === 'MASTER'
              ? 'Master template selected'
              : 'Abiturient template selected'
      );

      const isRusEdu = this.application.educationLanguage?.id === 2;
      const templateId = this.application.typeAbiturient === 'MASTER'
          ? (isRusEdu ? button.master_template_id_ru : button.master_template_id)
          : (isRusEdu ? button.abit_template_ru : button.abit_template_id);

      this.generateContract(templateId);
    }


  },
};
</script>

<template>
  <div class="pb-5">


    <admin-contract-page
        v-if="isContract && pdfData"
        :pdfData="pdfData"
        @close="
          () => {
            isContract = false;
            loading = false;
          }
        "
    />

    <admin-contract-schet-summ-page
        v-if="isInvoice && pdfData"
        :pdfData="pdfData"
        @close="
        () => {
          isInvoice = false;
          loading = false;
        }
      "
    />

    <admin-contract-schet-summ-page-pechat
        v-if="isInvoicePechat && pdfData"
        :pdf-data="pdfData"
        @close="
        () => {
          isInvoicePechat = false;
          loading = false;
        }
      "
    />


    <app-confirm
        v-if="canDelete"
        v-model="deleteDialog"
        :text="$t('Do you really want to delete?')"
        @accept="onDelete"
    />


    <v-container style="display: flex;">
      <v-btn
          @click="navigateToAdmin"
          elevation="0"
          rounded
          large
          class="font-made modern-back-btn mb-6 px-6 py-3 d-flex align-center"
          style="
          border: 1px solid #e0e0e0;
          background: linear-gradient(135deg, #ffffff, #f9f9f9);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
          transition: all 0.25s ease;
        "
      >
        <v-icon
            left
            size="22"
            style="color:#0c0c0c; transition: transform 0.2s;"
            class="back-icon"
        >
          mdi-arrow-left
        </v-icon>
        <span
            class="font-weight-bold text-uppercase"
            style="letter-spacing:1px; font-size:14px; color:#0c0c0c;"
        >
          {{ $t("Back") }}
        </span>
      </v-btn>

      <div class="-status-wrap" style="width: 100%; height: 100%;">

        <div
            class="-status"
            :style="{ backgroundColor: applicationStatus.color, color: textOn(applicationStatus.color) }"
        >
          {{ application.kurs }} - {{ $t("kurs talabasi") }}, {{ $t("Status") }}:
          {{ applicationStatus.name }}, {{ $t("Kontract summasi") }}
          {{ $comma(application.totalSumma) }}, {{ $t("Qoldiq") }}
          {{ $comma(application.totalOstatok) }}
        </div>
      </div>
    </v-container>


    <v-container>
      <div class="-status-wrap" style="width: 100%; height: 100%;">
        <div
            :style="{ backgroundColor: 'green' }"
            v-if="application.promotion > 0"
            class="-status"
            v-text="getVaucherText(application.promotion)"
        />
      </div>
    </v-container>

    <v-container class="-wrap">
      <div class="pa-5">
        <div header>
          <div class="title pb-2 text-center accent--text tab-title brand-title" v-text="$t(tab)"/>


          <div class="title-actions pb-5">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    elevation="0"
                    color="accent"
                    @click="tab = tabs.personal"
                    :outlined="tab != tabs.personal"
                    class="px-0"
                    v-bind="attrs"
                    v-on="on"
                >
                  <v-icon> mdi-badge-account-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Personal info") }}</span>
            </v-tooltip>

            <v-tooltip
                v-if="canUpdate"
                bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    @click="onEdit"
                    :outlined="tab != tabs.edit"
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                >
                  <v-icon> mdi-file-document-edit-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>

            <v-tooltip
                v-if="canUpdate"
                bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    @click="onCredit"
                    :outlined="tab != tabs.credit"
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                >
                  <v-icon>mdi-history</v-icon>
                </v-btn>
              </template>
              <span>Kredit tarixi</span>
            </v-tooltip>

            <v-tooltip
                bottom
                v-if="canUpdate"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    @click="onPromotion"
                    :outlined="tab != tabs.promotion"
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                >
                  <v-icon> mdi-credit-card-multiple</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("promotion") }}</span>
            </v-tooltip>

            <v-tooltip v-if="canCreate" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    @click="onPayment"
                    :outlined="tab != tabs.payment"
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                >
                  <v-icon> mdi-credit-card-multiple </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Payment") }}</span>
            </v-tooltip>

            <v-tooltip v-if="canUpdate" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    @click="onAddModel"
                    :outlined="tab != tabs.groupAdd"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5">
                  <v-icon> mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Add Group Number") }}</span>
            </v-tooltip>

            <v-tooltip v-if="canUpdate"
                bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    @click="onEditContractNumber"
                    :outlined="tab != tabs.editContractNumber"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5">
                  <v-icon> mdi-file-document-edit-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Edit Contract Number") }}</span>
            </v-tooltip>

            <v-tooltip v-if="canDelete"
                       bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    large
                    color="red darken-2"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                    @click="deleteDialog = true"
                >
                  <v-icon>mdi-trash-can</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>

            <v-tooltip v-if="!isBitrixManager" bottom>
              <template v-slot:activator="{ on, attrs }" v-if="application.paidStatus !== 'PAID'">
                <v-btn
                    :disabled="loading"
                    large
                    color="accent"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="px-0 ml-5"
                    @click="generateContract(application.typeAbiturient === 'MASTER' ? 3000 : (application.educationLanguage && application.educationLanguage.id === 2 ? 10001 : 1000))"
                >
                  <v-icon> mdi-file-pdf</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("download_сontract_schet_pechat") }}</span>
            </v-tooltip>
          </div>

          <div v-if="!isBitrixManager" class="d-flex flex-wrap justify-start align-center">
            <v-btn
                v-for="(button, index) in buttons"
                :key="index"
                class="contract-btn ma-2"
                outlined
                tile
                @click="handleContractClick(button)"
            >
              {{ button.label }}
            </v-btn>
          </div>


          <div class="position-relative">
            <v-progress-linear
                top
                absolute
                :active="loading"
                indeterminate
                posi
            />


          </div>


          <div class="text-center">
            <img src="@/assets/icons/devider.svg" alt=""/>
          </div>
        </div>

        <div body class="pt-5">
          <admin-contract-paid-show2025 v-if="tab == tabs.personal"/>
          <admin-contract-paid-edit2025 v-else-if="tab == tabs.edit"/>
          <add-group-number2025 v-else-if="tab == tabs.groupAdd"/>
          <AdminContractPaidPayment2025 v-else-if="tab == tabs.payment"/>
          <EditContractNumber2025 v-else-if="tab == tabs.editContractNumber"/>
          <AdminAddPromotion2025 :contract="application" v-else-if="tab == tabs.promotion"/>

          <CreditHistory
              v-else-if="tab == tabs.credit"
              :contract-id="application.id"
              :contract-number="application.contractNumber"
              :study-year="'2025-2026'"
              :permission-panel="'KONTRAKT_25_26'"
              :api-base="'/credit/history'"
              :application="application"
          />

        </div>
      </div>

    </v-container>

    <!-- <v-container class="mt-10">
      <v-card outlined>
        <v-card-title>
          <span class="text-h6">Comments</span>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-textarea
            v-model="newComment"
            label="Write a comment..."
            auto-grow
            rows="1"
            :disabled="postingComment"
            class="mb-4"
          ></v-textarea>
          <v-btn
            color="primary"
            @click="postComment"
            :loading="postingComment"
            :disabled="!newComment.trim()"
          >
            Post
          </v-btn>

          <v-divider class="my-4" />

          <v-skeleton-loader v-if="loadingComments" type="list-item@3" />
          <div v-else>
            <div v-for="(comment, index) in comments" :key="index" class="mb-4">
              <div class="font-weight-bold mb-1">
                {{ comment.firstName }} {{ comment.lastName }}
              </div>
              <div class="grey--text">
                {{ comment.comment }}
              </div>
              <v-divider class="my-3" />
            </div>
            <div v-if="comments.length === 0" class="grey--text text-center">
              No comments yet.
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-container> -->

    <!-- px-0: the card spans the same edges as the grey panel above (a container pads 12px a side). -->
    <v-container class="px-0">
      <contract-comments
          :contract-id="application?.id || Number($route.params.id)"
          :api-base="'admin/contract2025/comment'"
          :page-size="20"
          :infinite="true"
          :current-user="{ firstName: user.firstName, lastName: user.lastName }"
          :allow-all-edits="isSupperAdmin || isAccounter || isAccounterHelper || isQabulQiluvchi"
          :readonly="isBitrixManager"
          @loaded="evt => { /* optional badge refresh */ }"
          @count="n => { /* store if needed */ }"
          @changed="evt => { /* handle create/update/delete */ }"
          @error="e => { console.error('comments error', e) }"

          :current-user-id="user.id"
          :current-user-roles="user.roles"

      />

    </v-container>


  </div>
</template>

<style lang="scss" scoped>
.-status-wrap {
  display: flex;
  justify-content: center;

  .-status {
    padding: 8px 5px;
    border-radius: 10px;
    margin-left: 35px;
    margin-right: 35px;
    width: 100%;
    text-align: center;
    cursor: default;
    font-size: 18px;
    color: white;
  }
}

.-wrap {
  background: rgba(154, 154, 154, 0.2);
  border-radius: 10px;

  .title-actions {
    .v-btn {
      min-width: 44px;
    }
  }
}

.contract-btn {
  font-weight: 600;
  font-size: 14px;
  border-radius: 14px;
  border: 1px solid #d5dbe0;
  color: #2c3e50;
  background-color: #f9f9f9;
  text-transform: none;
  min-width: 200px;
  height: 46px;
}

.modern-back-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12);
}

.modern-back-btn:active {
  transform: translateY(0);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.back-icon:hover {
  transform: translateX(-3px);
}


</style>
  